const displayFilters = [
    {
        filterDisplayName: "Bricks",
        filterType: "collection",
        filterHandle: "new-display-bricks-baseplates-and-backpanels",
        subFilters: false,
    },
    {
        filterDisplayName: "Baseplates",
        filterType: "collection",
        filterHandle: "baseplates",
        subFilters: false,
    },
    {
        filterDisplayName: "Backpanels",
        filterType: "collection",
        filterHandle: "backpanel-displays",
        subFilters: false,
    },
    {
        filterDisplayName: "Laser Cut Back Panels",
        filterType: "collection",
        filterHandle: "laser-cut-back-panels",
        subFilters: false,
    },
    {
        filterDisplayName: "Minibuilds",
        filterType: "collection",
        filterHandle: "displays",
        subFilters: false,
    },
    {
        filterDisplayName: "Keychains & more",
        filterType: "collection",
        filterHandle: "keychains-more",
        subFilters: false,
    },
]

export { displayFilters }
